export enum Role {
    BROKER='BROKER',
    BROKER_STAFF='BROKER_STAFF',
    UNDERWRITER='UNDERWRITER',
    UNDERWRITER_STAFF='UNDERWRITER_STAFF',
    INSURER='INSURER',
    INSURER_STAFF='INSURER_STAFF',
    CLIENT='CLIENT',
    CLIENT_STAFF='CLIENT_STAFF',
    SPOT_CLIENT='SPOT_CLIENT',
    INSURER_AUDIT='INSURER_AUDIT',
    UNDERWRITER_AUDIT='UNDERWRITER_AUDIT',
    ROLE_ADMIN="ROLE_ADMIN",
    ADMIN_STAFF="ADMIN_STAFF",
    AUDIT_USER='AUDIT_USER',
    AUDIT_USER_STAFF='AUDIT_USER_STAFF',
    CLAIMANT = 'CLAIMANT'
}